import * as z from "zod";

export const ManagedMerchantWithReturnsSchema = z.object({
  teamId: z.string(),
  name: z.string(),
});

export type ManagedMerchantWithReturns = z.infer<
  typeof ManagedMerchantWithReturnsSchema
>;

export const getManagedMerchantsWithReturns = {
  name: "getManagedMerchantsWithReturns" as const,
  input: z.object({}),
  output: z.object({ merchants: z.array(ManagedMerchantWithReturnsSchema) }),
};
